'use client';

import CheckIcon from '@mui/icons-material/Check';
import { Box, Typography, useTheme } from '@mui/material';

import { ComponentSharedArticleExplainer } from '@/types';

interface ArticleExplainerCardProps {
  explainer?: ComponentSharedArticleExplainer | null;
}

export function ArticleExplainerCard({ explainer }: ArticleExplainerCardProps) {
  const theme = useTheme();
  const items = explainer?.Items?.filter(Boolean) ?? [];

  if (!items.length) return null;

  return (
    <Box
      data-component="ArticleExplainerCard"
      sx={{
        borderLeft: `3px solid ${theme.palette.brand.primarySecondary1}`,
        borderRadius: 2,
        bgcolor: theme.palette.purple[100],
        px: { xs: 3, md: 4 },
        py: { xs: 3, md: 3.5 },
      }}
    >
      <Typography
        variant="h5"
        sx={{
          color: theme.palette.brand.primarySecondary1,
          fontWeight: 700,
          mb: 3,
        }}
      >
        {explainer?.Title || 'In this article we explain:'}
      </Typography>

      <Box
        component="ul"
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' },
          columnGap: { xs: 2, md: 7 },
          rowGap: 2,
          listStyle: 'none',
          p: 0,
          m: 0,
        }}
      >
        {items.map((item) => (
          <Box
            key={item?.id}
            component="li"
            sx={{
              display: 'grid',
              gridTemplateColumns: '1.25rem 1fr',
              gap: 1.5,
              alignItems: 'start',
              color: theme.palette.text.primary,
            }}
          >
            <CheckIcon
              sx={{
                fontSize: 18,
                mt: '0.1rem',
                color: theme.palette.brand.primarySecondary1,
              }}
            />
            <Typography variant="body2" sx={{ lineHeight: 1.55 }}>
              {item?.BoldText && <Box component="strong">{item.BoldText} </Box>}
              {item?.Text}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
